export default angular.module('syMyAccount', [])
    .config(function ($httpProvider) {
        $httpProvider.defaults.withCredentials = true;
    })
    /**
     * @ngdoc provider
     * @name syMyAccount.provider:myAccountRequest
     * @restrict A
     * @description
     * Provider to send a HTTP request to the Synergy REST API. This
     * provider is a highlevel wrapper for the synergyAppsHttp provider.
     * It will validate errors and provide sanitise values on failure.
     */
    // @ngInject
    .provider('myAccountRequest', function () {
        // Return true when url is within the synergy.net.au domain
        // @param url {string} a URL for API request
        function isInSynergyDomain(url) {
            if (!url || typeof url !== 'string') {
                return false;
            }
            var domains = url.match(/:\/\/(.[^/]+)/) || [];
            return domains.length > 0 && domains[1].indexOf('.synergy.net.au') !== -1;
        }
        // Handle a failed API response by setting error messaging
        // @param response {object} The My Account REST response object
        function handleErrorResponse(response) {
            var errors = {};
            if (response.status === 500 || !response.data || !angular.isObject(response.data)) {
                errors.server = 'Unexpected server error';
                return errors;
            }
            if ('fieldErrors' in response.data) {
                angular.forEach(response.data.fieldErrors, function (error, field) {
                    errors[field] = error;
                });
            }
            if ('serverError' in response.data) {
                errors.server = response.data.serverError;
            }
            return errors;
        }
        // Send and HTTP request and provide a response to the user
        this.$get = ['$http', '$q', function ($http, $q) {
            return function (method, url, data,type) {
                var deferred = $q.defer();
                $http({
                    method: method,
                    url: url,
                    data: data
                })
                    .then(function (response) {
                        if (response.data.status === 'redirect' &&
                            isInSynergyDomain(response.data.to)) {
                            if (type === "login") {
                                return deferred.resolve(response);
                            }
                            window.location.href = response.data.to + response.data.dataAsUrl;
                        }
                        if (response.data.status === 'ok' || response.data.success === 'ok') {
                            return deferred.resolve();
                        }
                        return deferred.reject(handleErrorResponse(response));
                    }, function (response) {
                        return deferred.reject(handleErrorResponse(response));
                    });
                return deferred.promise;
            };
        }];
    })
    /**
     * @ngdoc service
     * @name syMyAccount.service:MyAccountService
     * @description
     * Service provides controller over the entire MyAccount
     * process so independent controllers can update the current state
     * of the form allowing users to move acround the login, forgot x forms
     * and handle success messages.
     */
    // @ngInject
    .service('MyAccountService', function ($timeout, AnalyticsService) {
        var TRACKING_NAME = {
            myAccountForgotPassword: 'forgot-password',
            myAccountForgotUsername: 'forgot-username'
        };
        var currentForm = 'myAccountLogin';
        var successfulForm = null;
        // Return true if form is currently successful
        // @param form {string} The form to validate as successful
        this.isSuccessfulForm = function (form) {
            return successfulForm === form;
        };
        // Set the provided form as successful
        // @param form {string} The form to set as successful
        this.setSuccessfulForm = function (form) {
            $timeout(function () {
                successfulForm = form;
            });
        };
        // Returns true if form is the currently active form
        // @param form {string} The form to validate
        this.isActiveForm = function (form) {
            return currentForm === form;
        };
        // Set the current my account form
        // @param form {string} The current form to view
        this.setActiveForm = function (form) {
            $timeout(function () {
                var previousForm = currentForm;
                currentForm = form;
                if (previousForm !== 'myAccountLogin') {
                    AnalyticsService.trackPage(['utilities/my-account', TRACKING_NAME[previousForm] || previousForm, 'close'].join('/'));
                }
                else if (currentForm !== 'myAccountLogin') {
                    AnalyticsService.trackPage(['utilities/my-account', TRACKING_NAME[currentForm] || currentForm, 'open'].join('/'));
                }
            });
        };
    })
    /**
     * @ngdoc directive
     * @name syMyAccount.directive:syMyAccount
     * @restrict A
     * @description
     * Creates a new scope to track the current My Account form state.
     */
    // @ngInject
    .directive('syMyAccount', function (MyAccountService) {
        return {
            restrict: 'A',
            scope: true,
            controller: function () {
                this.isActiveForm = MyAccountService.isActiveForm;
                this.isSuccessfulForm = MyAccountService.isSuccessfulForm;
            },
            controllerAs: 'myAccountController'
        };
    })
    /**
     * @ngdoc directive
     * @name syMyAccount.directive:syShowLogin
     * @restrict A
     * @description
     * Allows users to show the My Account Login form on click.
     */
    // @ngInject
    .directive('syShowLogin', function (MyAccountService) {
        return {
            restrict: 'A',
            link: function ($scope, $element) {
                $element.on('click', function (e) {
                    e.preventDefault();
                    MyAccountService.setActiveForm('myAccountLogin');
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name syMyAccount.directive:syShowForgotUsername
     * @restrict A
     * @description
     * Allows users to show the My Account Forgot Username form on click.
     */
    // @ngInject
    .directive('syShowForgotUsername', function (MyAccountService) {
        return {
            restrict: 'A',
            link: function ($scope, $element) {
                $element.on('click', function (e) {
                    e.preventDefault();
                    MyAccountService.setActiveForm('myAccountForgotUsername');
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name syMyAccount.directive:syShowForgotPassword
     * @restrict A
     * @description
     * Allows users to show the My Account Forgot Password form on click.
     */
    // @ngInject
    .directive('syShowForgotPassword', function (MyAccountService) {
        return {
            restrict: 'A',
            link: function ($scope, $element) {
                $element.on('click', function (e) {
                    e.preventDefault();
                    MyAccountService.setActiveForm('myAccountForgotPassword');
                });
            }
        };
    })
    /**
     * @ngdoc controller
     * @name syMyAccount.controller:MyAccountLoginController
     * @description
     * Allows the user to submit a My Account login request. Validates
     * their credentials and redirects to My Account on success, or presents
     * the user with validation or error messages on failure.
     */
    // @ngInject
    .controller('MyAccountLoginController', function ($scope, AnalyticsService, myAccountRequest) {
        var controller = this;
        this.formName = 'myAccountLogin';
        this.method = 'POST';
        this.apiURL = 'https://selfserve-qa.test.synergy.dev/apps/json/session/externalLogin';
        this.redirectURL = 'https://selfserve-qa.test.synergy.dev/myaccount/#/home';
        this.errors = {};
        this.formSubmitted = false;
        // Initialize form fields
        $scope.username = null;
        $scope.password = null;
        // Returns true when provided field has a server error
        // @param field {string} The field to check for an error
        this.hasServerError = function (field) {
            field = field || 'server';
            return !!controller.errors[field];
        };
        // Attempt to login to My Account over AJAX and handle the
        // the response accordingly. If successful redirect the user
        // to the My Account page otherwise set error messages
        this.submit = function () {
            var data = {
                username: $scope.username,
                password: $scope.password
            };
            myAccountRequest(controller.method, controller.apiURL, data, "login")
                // On success redirect the user to My Account, logged in
                .then(function (response) {
                    controller.errors = {};
                    controller.formSubmitted = true;
                    setTimeout(function () {
                        if (response.data.status === 'redirect') {
                            window.location.href = response.data.to + response.data.dataAsUrl;
                        } else {
                            return AnalyticsService.trackPage([window.location.pathname, 'forms', controller.formName, 'success'].join('/'), function () {
                                window.location = controller.redirectURL;
                            });
                        }
                    }, 200);

                },
                    // On error update local errors for user display
                    function (errors) {
                        controller.errors = errors;
                        return AnalyticsService.trackPage([window.location.pathname, 'forms', controller.formName, 'error'].join('/'));
                    });
        };
    })
    /**
     * @ngdoc directive
     * @name syMyAccount.directive:syMyAccountLogin
     * @restrict A
     * @description
     * Creates the scope for a MyAccountLoginController controller and
     * initializes overrides for API request configuration.
     */
    // @ngInject
    .directive('syMyAccountLogin', function () {
        return {
            restrict: 'A',
            scope: true,
            controller: 'MyAccountLoginController',
            controllerAs: 'myAccountLoginController',
            link: function ($scope, $element, attrs, controller) {
                if (attrs.name) {
                    controller.formName = attrs.name;
                }
                if (attrs.method) {
                    controller.method = attrs.method;
                }
                if (attrs.syMyAccountRestMethod) {
                    controller.apiURL = attrs.syMyAccountRestMethod;
                }
                if (attrs.syMyAccountHome) {
                    controller.redirectURL = attrs.syMyAccountHome;
                }
            }
        };
    })
    /**
     * @ngdoc controller
     * @name syMyAccount.controller:ForgotUsernameController
     * @description
     * Allows the user to submit a My Account Forgot Username request. Validates
     * their credentials and provides a success message and redirect to the
     * login form on success, or presents the user with validation or error
     * messages on failure.
     */
    // @ngInject
    .controller('ForgotUsernameController', function ($scope, MyAccountService, AnalyticsService, myAccountRequest) {
        var controller = this;
        this.formName = 'myAccountForgotUsername';
        this.method = 'POST';
        this.apiURL = 'https://selfserve-qa.test.synergy.dev/apps/json/forgottenCredentials/requestUsername';
        this.errors = {};
        // Initialize form fields
        $scope.emailAddress = null;
        // Returns true when provided field has a server error
        // @param field {string} The field to check for an error
        this.hasServerError = function (field) {
            field = field || 'server';
            return !!controller.errors[field];
        };
        // Send request for a Forgot Username email. If the email
        // address exists with an account exists provide a
        // success message otherwise provide an error message to the user
        this.submit = function () {
            var data = {
                emailAddress: $scope.emailAddress
            };
            myAccountRequest(controller.method, controller.apiURL, data)
                // On show message on My Account Login view
                .then(function (response) {
                    controller.errors = {};
                    MyAccountService.setSuccessfulForm('myAccountForgotUsername');
                    MyAccountService.setActiveForm('myAccountLogin');
                    return AnalyticsService.trackPage([window.location.pathname, 'forms', controller.formName, 'success'].join('/'));
                },
                    // On error update local errors for user display
                    function (errors) {
                        controller.errors = errors;
                        return AnalyticsService.trackPage([window.location.pathname, 'forms', controller.formName, 'error'].join('/'));
                    });
        };
    })
    /**
     * @ngdoc directive
     * @name syMyAccount.directive:syForgotUsername
     * @restrict A
     * @description
     * Creates the scope for a syMyAccountForgotUsernameController controller
     * and initializes overrides for API request configuration.
     */
    // @ngInject
    .directive('syForgotUsername', function () {
        return {
            restrict: 'A',
            scope: true,
            controller: 'ForgotUsernameController',
            controllerAs: 'forgotUsernameController',
            link: function ($scope, $element, attrs, controller) {
                if (attrs.name) {
                    controller.formName = attrs.name;
                }
                if (attrs.method) {
                    controller.method = attrs.method;
                }
                if (attrs.syMyAccountRestMethod) {
                    controller.apiURL = attrs.syMyAccountRestMethod;
                }
            }
        };
    })
    /**
     * @ngdoc controller
     * @name syMyAccount.controller:ForgotPasswordController
     * @description
     * Allows the user to submit a My Account Forgot Password request. Validates
     * their credentials and provides a success message and redirect to the
     * login form on success, or presents the user with validation or error
     * messages on failure.
     */
    // @ngInject
    .controller('ForgotPasswordController', function ($scope, MyAccountService, AnalyticsService, myAccountRequest) {
        var controller = this;
        this.method = 'POST';
        this.apiURL = 'https://selfserve-qa.test.synergy.dev/apps/json/forgottenCredentials/requestPassword';
        this.errors = {};
        // Initialize form fields
        $scope.usernameOrEmailAddress = null;
        // Returns true when provided field has a server error
        // @param field {string} The field to check for an error
        this.hasServerError = function (field) {
            field = field || 'server';
            return !!controller.errors[field];
        };
        // Send request for a Forgot Password email. If the username or
        // email exists provide a success message otherwise provide an
        // error message to the user
        this.submit = function () {
            var data = {
                usernameOrEmailAddress: $scope.usernameOrEmailAddress
            };
            myAccountRequest(controller.method, controller.apiURL, data)
                // On success redirect the user to My Account, logged in
                .then(function () {
                    controller.errors = {};
                    MyAccountService.setSuccessfulForm('myAccountForgotPassword');
                    MyAccountService.setActiveForm('myAccountLogin');
                    return AnalyticsService.trackPage([window.location.pathname, 'forms', controller.formName, 'success'].join('/'));
                },
                    // On error update local errors for user display
                    function (errors) {
                        controller.errors = errors;
                        return AnalyticsService.trackPage([window.location.pathname, 'forms', controller.formName, 'error'].join('/'));
                    });
        };
    })
    /**
     * @ngdoc directive
     * @name syMyAccount.directive:syForgotPassword
     * @restrict A
     * @description
     * Creates the scope for a syMyAccountForgotPasswordController controller
     * and initializes overrides for API request configuration.
     */
    // @ngInject
    .directive('syForgotPassword', function () {
        return {
            restrict: 'A',
            scope: true,
            controller: 'ForgotPasswordController',
            controllerAs: 'forgotPasswordController',
            link: function ($scope, $element, attrs, controller) {
                if (attrs.name) {
                    controller.formName = attrs.name;
                }
                if (attrs.method) {
                    controller.method = attrs.method;
                }
                if (attrs.syMyAccountRestMethod) {
                    controller.apiURL = attrs.syMyAccountRestMethod;
                }
            }
        };
    })
    /**
     * @ngdoc controller
     * @name syMyAccount.controller:PayMyBillController
     * @description
     * Allows the user to submit a Pay My Bill request. Validates
     * their information and redirects to finalize the payment through
     * My Account on success, or presents the user with validation or error
     * messages on failure.
     */
    // @ngInject
    .controller('PayMyBillController', function ($scope, myAccountRequest) {
        var controller = this;
        this.method = 'POST';
        this.apiURL = 'https://selfserve-qa.test.synergy.dev/apps/json/payment/generatePaymentToken';
        this.errors = {};
        // Initialize form fields
        $scope.paymentNumber = null;
        $scope.amountInDollars = null;
        // Returns true when provided field has a server error
        // @param field {string} The field to check for an error
        this.hasServerError = function (field) {
            field = field || 'server';
            return !!controller.errors[field];
        };
        // Send request for a Payment Token and a redirect link that
        // will send the user to a prefilled form with the ability to
        // pay their bill
        this.submit = function () {
            var data = {
                paymentNumber: $scope.paymentNumber.split(" ").join(""),
                amountInDollars: $scope.amountInDollars
            };
            myAccountRequest(controller.method, controller.apiURL, data)
                // On success redirect the user to My Account, logged in
                .then(function () {
                    controller.errors = {};
                },
                    // On error update local errors for user display
                    function (errors) {
                        controller.errors = errors;
                    });
        };
    })
    /**
     * @ngdoc directive
     * @name syMyAccount.directive:syPayMyBill
     * @restrict A
     * @description
     * Creates the scope for a PayMyBillController controller
     * and initializes overrides for API request configuration.
     */
    // @ngInject
    .directive('syPayMyBill', function () {
        return {
            restrict: 'A',
            scope: true,
            controller: 'PayMyBillController',
            controllerAs: 'payMyBillController',
            link: function ($scope, $element, attrs, controller) {
                if (attrs.method) {
                    controller.method = attrs.method;
                }
                if (attrs.syMyAccountRestMethod) {
                    controller.apiURL = attrs.syMyAccountRestMethod;
                }
            }
        };
    });
